module.exports = __webpack_public_path__ + "img/events.cf42de37.png";